import { StoreUtils } from '@/shared/util/store-utils'
import { HelperUtils } from '@/shared/util/helper-utils'
import { getPatientTimeOld } from '@/utils/fieldTransformations'
import { PromiseUtils } from '@/shared/util/promise-utils'
import { ToastUtils } from '@/shared/util/toast-utils'
import { ModalUtils } from '@/shared/util/modal-utils'
import moment from 'moment'
import { isEmpty } from 'lodash'

export default {
    computed: {
        globalParameters() {
            return StoreUtils.globalParameters
        }
    },
    methods: {
        cleanComponentData() {
            Object.assign(this.$data, this.$options.data.apply(this))
        },
        defaultComboCustomLabel({ code, description }) {
            return `${code} | ${description}`
        },
        isEmpty(value) {
            return isEmpty(value)
        },
        openUrl(query) {
            HelperUtils.openUrl(query)
        },
        cleanSearchStateGlobalMixin() {
            StoreUtils.cleanSearchState()
        },
        getPatientTimeOld(patBirthdate) {
            return getPatientTimeOld(patBirthdate)
        },
        handleErrors(response) {
            PromiseUtils.handleErrors(response)
        },
        updateSideBarOptionChildren(options, id, newOptions) {
            HelperUtils.updateSideBarOptionChildren(options, id, newOptions)
        },
        toCall(promise, showError = false) {
            return promise
                .then(data => {
                    return [null, data]
                })
                .catch(err => {
                    if (showError) {
                        this.showErrorModalGlobalFromErrorResponse(err)
                    }
                    return [err]
                })
        },

        updateLoading(state) {
            StoreUtils.updateLoading(state)
        },
        updateModalStateGlobal(state) {
            this.$store.commit('updateModalStateMessage', state)
        },

        showToastSuccessGlobal(message, title) {
            ToastUtils.showToastSuccess(message, title)
        },
        showSuccessModalGlobal(message) {
            ModalUtils.showSuccessModal(message)
        },
        showErrorModalGlobal(message) {
            ModalUtils.showErrorModal(message)
        },
        showErrorModalGlobalFromErrorResponse(error, alternativeMessage) {
            ModalUtils.showErrorModalFromErrorResponse(error, alternativeMessage)
        },
        saveNoFilter(message = this.$t('component.addFilterModal.noFilter')) {
            ModalUtils.showWarningModal(message)
        },

        removeExtensionFromFilename(filename) {
            return HelperUtils.removeExtensionFromFilename(filename)
        },
        async showConfirmationModalGlobal(question, okTitle, cancelTitle, qaId, cancelOnHide) {
            return new Promise((resolve) => {
                this.$eventHub.$emit('showConfirmationModal', { question, okTitle, cancelTitle, qaId, cancelOnHide })
                this.$eventHub.$on('confirmationModalResponse', (response) => {
                    resolve(response)
                    this.$eventHub.$off('confirmationModalResponse')
                })
            })
        },
        async processBasicConcurrencyConflict(entityName, error, updateEntityAndTryAgainFunction) {
            const basicConcurrencyQuestion = this.$t('global.error.basicConcurrency',
                { username: error.response.data.currentConcurrencyUpdatedBy.username,
                    timeSince: moment(error.response.data.currentConcurrencyUpdatedAt).fromNow(),
                    entityName })
            const shouldReplaceExistingDataWithMyData = await this.showConfirmationModalGlobal(basicConcurrencyQuestion)
            if (shouldReplaceExistingDataWithMyData) {
                return updateEntityAndTryAgainFunction()
            }
            return null
        },
        removeExternalOptionFromEntityObjects(entity) {
            return HelperUtils.removeExternalOptionFromEntityObjects(entity)
        },

        hasLabOperationGlobalMixin(laboratoryId, operationCode) {
            return HelperUtils.hasLabOperation(laboratoryId, operationCode)
        },
        hasOperationInCurrentLaboratoryGlobalMixin(operationCode) {
            return HelperUtils.hasOperationInCurrentLaboratory(operationCode)
        },
        hasOperationInAnyLaboratoryGlobalMixin(operationCode) {
            return HelperUtils.hasOperationInAnyLaboratory(operationCode)
        },
        hasGlobalOperationStartingWith(operationPrefix) {
            return HelperUtils.hasOperationStartingWith(operationPrefix)
        },
        hasLocalOperationStartingWith(operationPrefix) {
            return HelperUtils.hasLocalOperationStartingWith(operationPrefix)
        }
    }
}
